import { Button, Col, Popconfirm, Tag } from "antd";
import { EditOutlined, StopOutlined } from "@ant-design/icons";
import moment from "moment";

import Table from "../../../shared/components/ui/Table";
import { ipAccessRulesService } from "../../../shared/services";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { DataIpAccessRules } from "../../../redux/@types";
import { useTableIpAccessRules } from "../hook/useTableIpAccessRules";
import { useIpAccessRules } from "../hook";

export const TableIpAccessRules = () => {
  const { changeIpAccessRulesForUpdate } = useTableIpAccessRules();
  const { setTableProps, deactivateRule } = useIpAccessRules();

  const columns: TableColumns<DataIpAccessRules> = [
    {
      title: "ID",
      width: 4,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "IP",
      width: 10,
      dataIndex: "ip",
      key: "ip",
      filterType: "text",
    },
    {
      title: "Tipo",
      width: 8,
      dataIndex: "type",
      key: "type",
      filterType: "text",
      render: (_, item) =>
        item.type === "allow" ? (
          <Tag color="green">Lista blanca</Tag>
        ) : (
          <Tag color="red">Bloqueo</Tag>
        ),
    },
    {
      title: "Origen",
      width: 6,
      dataIndex: "source",
      key: "source",
      filterType: "text",
      render: (_, item) => (item.source === "auto" ? "Auto" : "Manual"),
    },
    {
      title: "Estado",
      width: 6,
      dataIndex: "status",
      key: "status",
      filterType: "text",
      render: (_, item) =>
        item.status === "active" ? (
          <Tag color="blue">Activa</Tag>
        ) : (
          <Tag>Inactiva</Tag>
        ),
    },
    {
      title: "Motivo",
      width: 14,
      dataIndex: "reason",
      key: "reason",
      filterType: "text",
    },
    {
      title: "Usuario rel.",
      width: 6,
      dataIndex: "related_user_id",
      key: "related_user_id",
    },
    {
      title: "Fecha",
      width: 10,
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, item) =>
        item.createdAt
          ? moment(item.createdAt).format("DD/MM/YYYY HH:mm")
          : "—",
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 8,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
              gap: 4,
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeIpAccessRulesForUpdate(item as any)}
              icon={<EditOutlined />}
              size="large"
            />
            {item.status === "active" && item.type === "block" && (
              <Popconfirm
                title="¿Desbloquear esta IP?"
                onConfirm={() => deactivateRule(item.id!)}
                okText="Sí"
                cancelText="No"
              >
                <Button
                  danger
                  shape="circle"
                  icon={<StopOutlined />}
                  size="large"
                  title="Desbloquear"
                />
              </Popconfirm>
            )}
          </Col>
        );
      },
    },
  ];

  return (
    <Table<DataIpAccessRules>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={ipAccessRulesService}
      onLoad={setTableProps}
    />
  );
};
